var render, staticRenderFns
import script from "./CrtServices.vue?vue&type=script&lang=js&"
export * from "./CrtServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05887ee5')) {
      api.createRecord('05887ee5', component.options)
    } else {
      api.reload('05887ee5', component.options)
    }
    
  }
}
component.options.__file = "src/views/Configuration/Services/CrtServices.vue"
export default component.exports